import React, { FC, RefObject, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { MentionData } from 'components/molecules/mention';
import { NewTaskPopup } from 'components/molecules/new-task-popup';
import { SquadData } from 'components/molecules/squad-picker/use-squad-options';
import { useTextSelection } from 'components/organisms/document/document-hooks/useTextSelection';
import {
  setBalloonToolbarDetails,
  useDocuments,
} from 'components/organisms/document/document-store';
import { appendToTasksDocMap, PopupType } from 'data/documents';
import { Task } from 'data/tasks';

export const CKTaskPopover: FC<{
  assignee: SquadData;
  mentionData: MentionData;
  canAddDate?: boolean;
  docId: number;
  docRef: RefObject<HTMLDivElement>;
  onSubmit(task: Partial<Task>): number;
}> = ({ assignee, mentionData, canAddDate, docId, docRef, onSubmit }) => {
  const [state, docDispatch] = useDocuments();
  const dispatch = useDispatch();
  const [selection, setSelection] = useState<string>('');

  const handleSelection = () => {
    // TODO: Support keyboard selection.
    const selctn = window.getSelection();

    setSelection(selctn?.toString() || '');
  };

  const closeForm = useCallback(() => {
    setBalloonToolbarDetails(docDispatch, {
      type: PopupType.BalloonToolbar,
      position: {
        x: 0,
        y: 0,
      },
    });
  }, [docDispatch]);

  const onFormSubmit = async (task: Partial<Task>) => {
    const descriptionWithDocRef = `<blockquote><p>${selection}</p></blockquote>${task.taskDescription}`;

    const _task = {
      ...task,
      taskDescription: descriptionWithDocRef,
    };

    const resourceSectionId = onSubmit(_task);

    dispatch(
      appendToTasksDocMap({
        [resourceSectionId]: {
          content: state.balloonToolbarDetails.type,
          isActive: true,
          parentDocId: docId,
        },
      }),
    );

    const taskRefId = `rl-task-${resourceSectionId}`;
    const options = {
      taskId: taskRefId,
    };

    state.editor?.execute('insertTaskCommand', options);
    state.editor?.editing.view.focus();

    closeForm();
  };

  useTextSelection(docRef, handleSelection);

  return (
    <NewTaskPopup
      assignee={{ options: assignee, isLoading: false }}
      showSimpleAssigneePicker
      canAddDate={canAddDate}
      visible={state.balloonToolbarDetails.type === PopupType.TaskForm}
      onClose={closeForm}
      onSubmit={onFormSubmit}
      mentionData={mentionData}
    >
      <div
        style={{
          top: state.balloonToolbarDetails.position.y,
          left: state.balloonToolbarDetails.position.x,
          position: 'fixed',
        }}
      />
    </NewTaskPopup>
  );
};
